import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [{
  exact: true,
  path: '/home/operated/infoFlowOperation',
  owner: '/home',
  authority: 'recommendOperationList',
  component: Loadable({
    loader: () => import('./list'),
    loading: () => <RouteLoading />
  })
},
{
  exact: true,
  path: '/home/operated/infoFlowOperation/new',
  owner: '/home',
  authority: 'recommendOperationAdd',
  component: Loadable({
    loader: () => import('./edit/new'),
    loading: () => <RouteLoading />
  })
},
{
  exact: true,
  path: '/home/operated/infoFlowOperation/:id/edit',
  owner: '/home',
  authority: 'recommendOperationMod',
  component: Loadable({
    loader: () => import('./edit/mod'),
    loading: () => <RouteLoading />
  })
}
]